import api from "../index";
import { apiUrl } from "../../utils/constants";

// Web dropdown consumers only read {id, name}; the backend `light=1` path drops
// the unused `categoryTags` preload. Settings needs the full payload with tags.
export const GetCategories = (params) => {
  return api.get(apiUrl.categories, { params: { ...(params || {}), light: 1 } });
};

export const GetCategoriesWithTags = (params) => {
  return api.get(apiUrl.categories, {
    params: { ...(params || {}), light: 0 },
  });
};

export const CreateCategory = (data) => api.post(apiUrl.categories, data);

export const UpdateCategory = (id, data) =>
  api.put(`${apiUrl.categories}/${id}`, data);

export const DeleteCategory = (id) =>
  api.delete(`${apiUrl.categories}/${id}`);
